export class ApiError extends Error {
  constructor(
    public override name: string,
    message: string,
    public contexts: {
      request: Record<string, unknown>;
      response: Record<string, unknown>;
    },
  ) {
    super(message);
  }
}

export class TimeoutError extends ApiError {
  constructor(contexts: { request: Record<string, unknown>; response: Record<string, unknown> }) {
    super("TimeoutError", "API call timed out", contexts);
  }
}

export class NoSuccessError extends ApiError {
  constructor(
    message: string,
    endpoint: string,
    contexts: { request: Record<string, unknown>; response: NoSuccessResponse },
  ) {
    super(`NoSuccessError: ${message}`, `Server call unsuccessful to ${endpoint}`, contexts);
  }

  get response(): NoSuccessResponse {
    return this.contexts.response as NoSuccessResponse;
  }
}

interface NoSuccessResponse extends Record<string, unknown> {
  message: string;
  code?: string;
  details?: unknown;
}
